import { Guid } from 'src/application/store/model/guid';

import { PreviouslySelectedOptionsForItems } from '../../../reducers/student/tracking/questionWidgetTrackingReducer';
import { TrackingIdentifier } from '@ael/core-api';
import * as Immutable from 'immutable';

export enum CourseCompletionStatus {
  Incomplete = 'incomplete',
  Completed = 'completed',
  Passed = 'passed',
  Failed = 'failed',
  NotAttempted = 'not attempted',
}

export interface QuizStatus {
  score: number | null;
  passed: boolean | null;
}

export enum TrackingDataVersion {
  v1 = 1,
  v2 = 2,
}
export interface TrackingData {
  finishedItems: Immutable.Set<Guid>;
  widgetTrackingData: PreviouslySelectedOptionsForItems;
  version: TrackingDataVersion;
}

export interface TrackingClient {
  setTrackingData(trackingData: TrackingData): Promise<void>;
  setCompletionStatus(status: CourseCompletionStatus): Promise<void>;
  setQuizStatus(quizStatus: QuizStatus): Promise<void>;
}

export type PersistenceTrackingData = {
  finishedItems: Immutable.Set<TrackingIdentifier>;
  widgetTrackingData: PreviouslySelectedOptionsForItems;
  version: TrackingDataVersion;
  quizStatus?: QuizStatus;
};

/* Declares contract for client responsible for persisting tracking data. */
export interface IPersistenceTrackingClient {
  name: string;
  doesSupportLegacyData: boolean;

  /* Initializes client, returns false if client cannot be initialized, e.g. underlying data source is not available. */
  init(): Promise<boolean>;

  /* Return tracking data from the persistent data source */
  getTrackingData(): Promise<PersistenceTrackingData>;

  /*
  * Is invoked after init and retrieving the tracking data, before student can make any progress in the course.
  * Can be used for e.g. logging that student has opened the course.
  */
  afterSetup(): Promise<void>;

  /* Sets new tracking data do the persistent storage, so that user can continue where they left. */
  setTrackingData(trackingData: PersistenceTrackingData): Promise<void>;

  /* Sets the completion status of the course for the current student. */
  setCompletionStatus(status: CourseCompletionStatus): Promise<void>;
  setQuizStatus(quizStatus: QuizStatus): Promise<void>;
}
